import axios from 'axios';
import Swal from 'sweetalert2';

const API = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

API.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },error => {
    return Promise.reject(error)
});

// Response interceptor to handle APP_DEPRECATED error
API.interceptors.response.use(
  response => response,
  error => {
    // Check if the error response contains APP_DEPRECATED code
    if (error.response && error.response.data && error.response.data.code === 'APP_DEPRECATED') {
      const errorData = error.response.data;
      const updateUrl = errorData.updateUrl || 'https://play.google.com/store/apps/details?id=ch.flohmarkt.app&pli=1';
      const updateMessage = errorData.updateMessage || errorData.message || 'Diese App-Version wird nicht mehr unterstützt. Bitte aktualisieren Sie die App im Play Store.';
      
      // Show alert with message and button to open Play Store
      Swal.fire({
        title: 'App veraltet',
        html: `<p>${updateMessage}</p>`,
        icon: 'warning',
        confirmButtonText: 'Im Play Store öffnen',
        showCancelButton: true,
        cancelButtonText: 'Schließen',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Open Play Store URL
          try {
            // Try Capacitor App plugin first (if available)
            if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.App) {
              await window.Capacitor.Plugins.App.openUrl({ url: updateUrl });
            } 
            // Try Capacitor Browser plugin (if available)
            else if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Browser) {
              await window.Capacitor.Plugins.Browser.open({ url: updateUrl });
            } 
            // Fallback to window.open (works in web and Capacitor)
            else {
              window.open(updateUrl, '_system');
            }
          } catch (err) {
            // Final fallback
            window.open(updateUrl, '_system');
          }
        }
      });
      
      // Return a rejected promise to prevent the request from continuing
      return Promise.reject(error);
    }
    
    // For other errors, pass them through
    return Promise.reject(error);
  }
);

export default API;
